import React, { useState } from 'react';
import { AppBar, Box, Tab, Tabs } from '@mui/material';
import CSS from 'csstype';
import { Colors } from '../../utils/theme';
import TabPanel from '../Common/Layout/TabPanel';
import NavTab from './Tabs/Nav/NavTab';
import ConstituentTab from './Tabs/Constituent/ConstituentTab';
import ClosePriceTab from './Tabs/ClosePriceTab';
import DividendGrossTab from './Tabs/DividendGross/DividendGrossTab';
import LtvTab from './Tabs/Ltv/LtvTab';
import KpiTab from './Tabs/Kpi/KpiTab';
import AwardsTab from './Tabs/Awards/AwardsTab';
import AllocationSectorTab from './Tabs/AllocationSector/AllocationSectorTab';
import AllocationCountryTab from './Tabs/AllocationCountry/AllocationCountryTab';
import RecalcsTab from './Tabs/Recalc/RecalcsTab';

interface IProps {
  stockId: string | undefined;
  stockName: string | undefined;
  currencyCode: string | undefined;
  companyName: string | undefined;
}

const StockTabs: React.FunctionComponent<IProps> = ({
  stockId,
  stockName,
  currencyCode,
  companyName
}: IProps) => {
  const [value, setValue] = useState(0);

  const getTabStyle = (index: number): CSS.Properties => {
    return {
      fontFamily: 'Overpass',
      fontSize: '14px',
      fontWeight: value === index ? 'bold' : 'normal',
      color: value === index ? Colors.skyBlue : Colors.main
    };
  };

  return (
    <Box sx={{ width: '100%' }}>
      <AppBar
        position="static"
        sx={{ backgroundColor: 'white', boxShadow: 'none', borderBottom: `1px solid #AACEF8` }}
      >
        <Tabs
          value={value}
          onChange={(_, newValue) => setValue(newValue)}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          TabIndicatorProps={{ style: { background: Colors.skyBlue } }}
        >
          <Tab id="stock-navs" label={`NAV's`} style={getTabStyle(0)} />
          <Tab id="stock-constituents" label="Constituents" style={getTabStyle(1)} />
          <Tab id="stock-close-prices" label="Close Prices" style={getTabStyle(2)} />
          <Tab id="dividend-gross" label="Dividend Gross" style={getTabStyle(3)} />
          <Tab id="stock-ltv" label="LTV" style={getTabStyle(4)} />
          <Tab id="stock-kpi" label="KPI" style={getTabStyle(5)} />
          <Tab id="stock-awards" label="Awards" style={getTabStyle(6)} />
          <Tab id="stock-sector-allocation" label="Sector Allocation" style={getTabStyle(7)} />
          <Tab
            id="stock-allocation-countries"
            label="Allocation Countries"
            style={getTabStyle(8)}
          />
          <Tab id="stock-recalcs" label="Recalcs" style={getTabStyle(9)} />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <NavTab stockId={stockId} stockName={stockName} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <ConstituentTab stockId={stockId as string} stockName={stockName as string} />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <ClosePriceTab
          stockId={stockId as string}
          stockName={stockName as string}
          currencyCode={currencyCode}
        />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <DividendGrossTab stockId={stockId as string} stockName={stockName as string} />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <LtvTab stockId={stockId} stockName={stockName} />
      </TabPanel>
      <TabPanel value={value} index={5}>
        <KpiTab
          stockId={stockId as string}
          currencyCode={currencyCode}
          companyName={companyName as string}
        />
      </TabPanel>
      <TabPanel value={value} index={6}>
        <AwardsTab stockId={stockId} />
      </TabPanel>
      <TabPanel value={value} index={7}>
        <AllocationSectorTab stockId={stockId as string} companyName={companyName as string} />
      </TabPanel>
      <TabPanel value={value} index={8}>
        <AllocationCountryTab stockId={stockId as string} />
      </TabPanel>
      <TabPanel value={value} index={9}>
        <RecalcsTab stockId={stockId as string} />
      </TabPanel>
    </Box>
  );
};

export default StockTabs;
